export const MODIFICATION_TYPE_DEFAULT = "default";
export const MODIFICATION_TYPE_TOGGLE = "toggle";